import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  coordenador: function(usuario) {
    return Vue.http.post('/api/login/coordenador', usuario);
  },
  verificarFornecedor: function (documento) {
    return Vue.http.post('/api/login/verificarfornecedor', { login: documento, senha: 'sem_senha' });
  },
  fornecedor: function (usuario) {
    return Vue.http.post('/api/login/fornecedor', usuario);
  },
  verificacaoDuasEtapasFornecedor: function (usuario) {
    return Vue.http.post('/api/login/verificacaoDuasEtapasFornecedor', usuario);
  },

  reenviarCodigoValidacao: function (usuario) {
    return Vue.http.post('/api/login/reenviarcodigovalidacao', usuario);
  },

  aluno: function(usuario) {
    if (usuario.dataNascimento) {
      usuario.dataNascimento = moment(usuario.dataNascimento, 'DD/MM/YYYY').format('MM/DD/YYYY')
    }

    return Vue.http.post('/api/login/aluno', usuario);
  },
  funcionario: function (usuario) {
    return Vue.http.post('/api/login/funcionario', usuario);
  },
  usuarioLogado: function() {
    return Vue.http.get('/api/login');
  },
  logout: function() {
    return Vue.http.delete('/api/login');
  },
  importacao: function (usuario) {
    return Vue.http.post('/api/login/importacao', usuario);
  },
  acessoEspecial: function (usuario) {
    return Vue.http.post('/api/login/acessoespecial', usuario);
  },
  verificarPessoaFisica: function (documento) {
    return Vue.http.post('/api/login/verificarpessoafisica', { login: documento, senha: 'sem_senha' });
  },
  pessoaFisica: function (usuario) {
    return Vue.http.post('/api/login/pessoa-fisica', usuario);
  },

  verificacaoDuasEtapasPessoaFisica: function (usuario) {
    return Vue.http.post('/api/login/verificacaoDuasEtapasPessoaFisica', usuario);
  },

  usuarioChat: function (usuario) {
    return Vue.http.post('/api/login/usuariochat', usuario);
  },
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/login/servico.js